package com.sweetlime.bingeamigo.util

import kotlin.math.roundToInt

fun Double.format1f(): String {
    val rounded = (this * 10).roundToInt() / 10.0
    return rounded.toString()
}

fun computeDisplayRating(tmdbVoteAverage: Double, communityAvgRating: Double?): Double {
    val tmdbOn5 = tmdbVoteAverage / 2.0
    return if (communityAvgRating != null && communityAvgRating > 0.0) {
        (tmdbOn5 + communityAvgRating) / 2.0
    } else {
        tmdbOn5
    }
}